<template>
  <h3 class="chart-header">{{title}}</h3>
</template>

<script>
export default {
  name: "AnalyticsHeader",
  props: {
    title: { type: String },
  }
}
</script>

<style scoped>
h3 {
  color: white;
  background: linear-gradient(124deg,#e74a23,#e9671f,#ec841b,#efa118);
  padding: 1.4vh 0;
  font-size: 3vh;
}
</style>



// WEBPACK FOOTER //
// src/components/analytics/AnalyticsHeader.vue